var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { Period } from '@/models/Period';
import { excludeRoles } from '@/support/ExcludeRoles';
import { DateTime } from 'luxon';
let AddPeriodDialog = class AddPeriodDialog extends Vue {
    constructor() {
        super(...arguments);
        this.period = new Period();
        this.startsAtmodal = false;
        this.endsAtmodal = false;
    }
    get maxDate() {
        if (!this.year) {
            return '';
        }
        return this.year.ends_at;
    }
    get minDate() {
        if (!this.year) {
            return '';
        }
        return this.year.starts_at;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolAdmin.years.date.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    create() {
        if (!this.year || !this.year.id) {
            return;
        }
        this.period.year = this.year.id;
        if (this.exclude) {
            this.setBlockDate();
        }
        this.period
            .create()
            .then((period) => {
            this.$emit('periodCreated');
            this.close();
        });
    }
    setBlockDate() {
        if (!this.periods || !this.year) {
            return;
        }
        let newStartDate;
        let newEndDate;
        if (!this.periods.length) {
            newStartDate = this.setNewDate(this.year.starts_at);
            newEndDate = this.setNewDate(newStartDate);
        }
        else {
            newStartDate = this.setNewDate(this.periods[this.periods.length - 1].ends_at);
            newEndDate = this.setNewDate(newStartDate);
        }
        this.period.starts_at = newStartDate;
        this.period.ends_at = newEndDate;
    }
    setNewDate(date) {
        return DateTime.fromSQL(date).plus({ days: 1 }).toFormat('yyyy-LL-dd');
    }
    clear() {
        this.periods = [];
        this.year = null;
        this.period = new Period();
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], AddPeriodDialog.prototype, "year", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Array)
], AddPeriodDialog.prototype, "periods", void 0);
AddPeriodDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], AddPeriodDialog);
export default AddPeriodDialog;
